import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import {
  FEE_NOTICE_ANCHOR_ID,
  FEE_NOTICE_END,
  FEE_NOTICE_POLL_INTERVAL_MS,
  FEE_NOTICE_SCROLL_GAP,
  FEE_NOTICE_SCROLL_OFFSET,
  FEE_NOTICE_START,
  FEE_NOTICE_TIMEZONE,
} from '../constants/feeChangeNotice';

const FEE_NOTICE_ENABLED = process.env.REACT_APP_ENABLE_FEE_CHANGE_NOTICE === 'true';

export const isWithinFeeNoticeWindow = (at: moment.Moment = moment()): boolean => {
  const now = at.clone().tz(FEE_NOTICE_TIMEZONE);
  const start = moment.tz(FEE_NOTICE_START, FEE_NOTICE_TIMEZONE);
  const end = moment.tz(FEE_NOTICE_END, FEE_NOTICE_TIMEZONE);

  return !now.isBefore(start) && now.isBefore(end);
};

export const useFeeChangeNoticeVisible = (): boolean => {
  const [visible, setVisible] = useState(() => FEE_NOTICE_ENABLED && isWithinFeeNoticeWindow());

  useEffect(() => {
    if (!FEE_NOTICE_ENABLED) {
      return undefined;
    }

    const check = () => setVisible(isWithinFeeNoticeWindow());
    check();
    const timer = window.setInterval(check, FEE_NOTICE_POLL_INTERVAL_MS);

    return () => window.clearInterval(timer);
  }, []);

  return visible;
};

const getPinnedChromeHeight = (): number => {
  const banner = document.querySelector('[data-testid="fee-change-banner"]');
  const header = document.querySelector('.ant-layout-header');
  const bottom = Math.max(
    banner?.getBoundingClientRect().bottom ?? 0,
    header?.getBoundingClientRect().bottom ?? 0,
  );

  return bottom > 0 ? bottom + FEE_NOTICE_SCROLL_GAP : FEE_NOTICE_SCROLL_OFFSET;
};

export const scrollToFeeNoticeBand = (): void => {
  const band = document.getElementById(FEE_NOTICE_ANCHOR_ID);

  if (!band) {
    return;
  }

  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
  const top = band.getBoundingClientRect().top + window.pageYOffset - getPinnedChromeHeight();

  window.scrollTo({
    top: Math.max(top, 0),
    behavior: prefersReducedMotion ? 'auto' : 'smooth',
  });
};
